export default "__VITE_ASSET__5cf5f0f7__"